import * as React from 'react';
import { connect } from 'react-redux';


type Props = {
  loading: boolean;
};

/**
 * SeleniumLoadingIndicator: an extremely simple component to present an invisible web element to assist
 * the selenium project. We will display a div with an ID indicating if the app is in a loading state. This will
 * speed up testing and allow for more stable element identification.
 *
 * PureComponent: true
 * Connected to Redux: true
 */
const SeleniumLoadingIndicator: React.FC<Props> = (props: Props) => <div id={`irt-loading-${props.loading}`}/>;

const mapStateToProps = (state) => ({loading: state.loading.count() > 0});

const areStatesEqual = (next, prev) => next.loading === prev.loading;

const connectOptions = ({areStatesEqual});

export default connect(mapStateToProps, null, null, connectOptions)(SeleniumLoadingIndicator);
